import { signal } from '@preact/signals';
import en from './en.json';
import ky from './ky.json';
import ru from './ru.json';

const dicts = { ru, ky, en } as const;
export type Locale = keyof typeof dicts;
export const availableLocales: readonly Locale[] = ['ru', 'ky', 'en'] as const;

const STORAGE_KEY = 'cpw:locale';

export function isLocale(x: unknown): x is Locale {
  return typeof x === 'string' && (availableLocales as readonly string[]).includes(x);
}

function fromLocalStorage(): Locale | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return isLocale(v) ? v : null;
  } catch {
    return null;
  }
}

function fromNavigator(): Locale {
  if (typeof navigator === 'undefined') return 'ru';
  const code = (navigator.language || 'ru').slice(0, 2).toLowerCase();
  return isLocale(code) ? code : 'ru';
}

export const locale = signal<Locale>(fromLocalStorage() ?? fromNavigator());

export function setLocale(next: Locale, persist = false): void {
  if (!isLocale(next) || next === locale.value) return;
  locale.value = next;
  if (persist) {
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  }
}

export function hasUserLocale(): boolean {
  return fromLocalStorage() !== null;
}

export function t(key: string): string {
  const dict = dicts[locale.value] as Record<string, string>;
  return dict[key] ?? key;
}
